import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 4/10;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 4 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-438.000000, -341.000000)" fill={color}>
                <g id="Group-10" transform="translate(421.000000, 180.000000)">
                    <g id="Group-7" transform="translate(11.000000, 158.000000)">
                        <path d="M6.328125,13 L7.85253906,5.78808594 L9.32910156,5.78808594 L7.8046875,13 L6.328125,13 Z M8.99414062,4.76953125 C8.515625,4.76953125 8.1328125,4.37988281 8.1328125,3.88769531 C8.1328125,3.39550781 8.515625,3.00585938 8.99414062,3.00585938 C9.47265625,3.00585938 9.85546875,3.39550781 9.85546875,3.88769531 C9.85546875,4.37988281 9.47265625,4.76953125 8.99414062,4.76953125 Z" id="Italic"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatBold extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
